export const SUPPORTED_LANGUAGES = ['pt', 'en'];

export const DEFAULT_LANGUAGE = 'pt';

// The login screen has no username yet, so the last language used on this
// device is the only signal available before auth resolves.
const DEVICE_KEY = 'delson.lang.__device';

const userKey = username => `delson.lang.${username}`;

const isSupported = value => SUPPORTED_LANGUAGES.includes(value);

function read(key) {
  try {
    const stored = window.localStorage.getItem(key);
    return isSupported(stored) ? stored : null;
  } catch {
    // Safari private mode throws on localStorage access. Fall back to default.
    return null;
  }
}

export function resolveInitialLanguage() {
  return read(DEVICE_KEY) ?? DEFAULT_LANGUAGE;
}

export function loadUserLanguage(username) {
  if (!username) return null;
  return read(userKey(username));
}

export function saveUserLanguage(username, lng) {
  if (!isSupported(lng)) return;
  try {
    if (username) window.localStorage.setItem(userKey(username), lng);
    window.localStorage.setItem(DEVICE_KEY, lng);
  } catch {
    // Non-fatal: the language still applies for this session.
  }
}
